<header class="headerBackground">
<div class="container">
  <nav class="navbar navbar-expand-lg navbar-dark pink scrolling-navbar" role="navigation">
    <a class="navbar-brand" target="_blank'" href="{{header?.logo?.linkURL}}" [class.disabled]="header?.logo?.linkURL === '' || header?.logo?.linkURL === null" id="logo"> 
      <div class="row">
        <img class="logo" title="{{header?.logo?.imageAltText}}" tabindex="0"  alt="{{header?.logo?.imageAltText}}" src="{{image}}" *ngIf="image" height="75px">
      </div>
    </a>
    
    <a class="navbar-brand nav-header-title"  href="{{navigate}}" id="headerTitle"> 
    <div class="row">
        <h1 class="col-12" class="header-title" style="display:inline; font-size:18px; align-self:center;word-wrap: break-word !important;white-space: normal;" tabindex="0">{{header?.headerTitle?.linkText}}</h1>
      </div>
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <ul class="navbar-nav ">
        <li class="nav-item active" *ngFor="let hp of header?.headerHyperLink;let i = index">

          <!-- <a class="nav-link" href="i == 0 ? '/helpcenter' : i== 1 ? '/home' : i== 2 ? '/login' : '/logout'" *ngIf="!hp?.partialURL">{{hp.linkText}} -->
          <a class="nav-link"  href="javascript:;" *ngIf="!hp?.partialURL && i < 2" style="cursor:pointer;" (click)=handleNavigation(i) >{{hp.linkText}}</a>
          <a class="nav-link" href="javascript:;" *ngIf="!hp?.partialURL && i == 2 && !authenticationService.isUserLoggedIn()" style="cursor:pointer;" (click)=handleNavigation(i) >{{hp.linkText}}</a>
          <a class="nav-link" href="javascript:;" *ngIf="!hp?.partialURL && i == 3 && authenticationService.isUserLoggedIn()" style="cursor:pointer;" (click)=handleNavigation(i) >{{hp.linkText}}</a>
          
        </li>
        <a class="nav-link" href="javascript:;" *ngIf="isUserLoggedIn && allowModifyPwd === 'yes' " style="cursor:pointer" id="modifypwdlink" (click)="checkPasswordModal = true;">Modify Password</a>        
      </ul>
    </div>
  </nav>
</div>
</header>

<app-modify-password *ngIf="checkPasswordModal" (checkIsPasswordModalOpen)= "checkIsPasswordModalOpen($event)"></app-modify-password>

<app-create-ticket *ngIf="checkCaseModal" (checkIsCaseModalOpen)="checkIsCaseModalOpen($event)"></app-create-ticket>


